import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconAngelAppSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="50" height="50" viewBox="0 0 50 50" className={classNames(['svg-icon svg-angel-app', className])}>
            <defs>
                <linearGradient id="svg-angel-app_a" x2="1" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stopColor="#2c80ed"/>
                    <stop offset="0.216" stopColor="#1794ec"/>
                    <stop offset="0.6" stopColor="#32cccc"/>
                    <stop offset="1" stopColor="#32cccc"/>
                </linearGradient>
            </defs>
            <g transform="translate(-32 -9.212)">
                <rect className="svg-angel-app_a" fill="url(#svg-angel-app_a)" width="50" height="50" rx="8" transform="translate(32 9.212)"/>
                <g transform="translate(-115 -229.788)">
                    <g transform="translate(169.999 257.588)">
                        <path className="svg-angel-app_b" fill={color} stroke={color} fillRule="evenodd"
                              d="M325.132,254.986a1.075,1.075,0,0,0-1.075,1.075v10.891a1.075,1.075,0,0,0,1.075,1.075h3.25a1.075,1.075,0,0,0,1.075-1.075v-.124a1.075,1.075,0,0,1,1.839-.762l1.648,1.647a1.075,1.075,0,0,0,.762.316H336a1.075,1.075,0,0,0,1.075-1.075v-2.3a1.075,1.075,0,0,0-.315-.762l-1.659-1.659a1.075,1.075,0,0,1,.761-1.84H336a1.075,1.075,0,0,0,1.075-1.075v-3.251A1.075,1.075,0,0,0,336,254.99Z"
                              transform="translate(-324.057 -254.986)"/>
                    </g>
                    <path className="svg-angel-app_c" fill={color}
                          d="M117,196.334c-.276,0-.554,0-.83,0a6.8,6.8,0,0,1-3.032-.788,7.223,7.223,0,0,1-2.077-1.628,8.164,8.164,0,0,1-1.363-2.141,8.931,8.931,0,0,1-.67-2.382c-.05-.364-.066-.372-.261-.476a7.807,7.807,0,0,1-4.019-6.209c-.091-.648-.177-.84-.485-1.08a7.834,7.834,0,0,1-2.784-4.581,10.892,10.892,0,0,1-.255-2.3c0-.005,0-.011,0-.016v-.014a2.7,2.7,0,0,1,2.7-2.731q1.006,0,2.012,0l1.058,0c5.806-.011,11.708-.01,17.415-.009h4.8a5.518,5.518,0,0,1,5.511,5.511V190.81a5.523,5.523,0,0,1-5.516,5.516H119.067c-.343,0-.686,0-1.028,0S117.348,196.334,117,196.334Zm-13.353-21.611a8.5,8.5,0,0,0,.194,1.782,5.405,5.405,0,0,0,1.914,3.212,3.684,3.684,0,0,1,1.391,2.652,5.444,5.444,0,0,0,2.762,4.409,2.757,2.757,0,0,1,1.52,2.284,6.512,6.512,0,0,0,.488,1.736,5.744,5.744,0,0,0,.957,1.508,4.778,4.778,0,0,0,1.37,1.08,4.406,4.406,0,0,0,1.956.522c.606.007,1.229,0,1.83,0,.347,0,.695,0,1.042,0H129.2a3.1,3.1,0,0,0,3.093-3.093V177.483a3.092,3.092,0,0,0-3.088-3.088h-4.8c-5.707,0-11.608,0-17.411.009l-1.056,0q-1.009,0-2.018,0a.269.269,0,0,0-.195.082.277.277,0,0,0-.081.2c0,.006,0,.011,0,.017Z"
                          transform="translate(53.779 80.029)"/>
                </g>
            </g>
        </svg>
    );
};

IconAngelAppSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconAngelAppSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconAngelAppSVG;